import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";

import {
  AuthService,
  FormLoaderService,
  FormValidationService,
} from "./../shared";
import { FormGroup } from "@angular/forms";
import { FORM_STATUS, MODE } from "../shared/constant";
import { Observable } from "rxjs";
import { Store } from "@ngrx/store";

@Component({
  selector: "questionnaire-form",
  templateUrl: "form.component.html",
  styleUrls: ["form.scss"],
})
export class FormComponent implements OnInit {
  @Input("formCode") formCode: string;
  @Input("formVerCode") formVerCode: string;
  @Input("formSubCode") formSubCode: string;
  @Input("env") env: any;
  @Input("mode") mode: string;
  @Input("enableSave") enableSave = false;

  @Output() statusChange: any = new EventEmitter<any>();
  form: FormGroup = new FormGroup({});
  isFormDisabled: any = null;
  survey: any;

  private campusCode: string;
  private disableButton = false;
  private isSubmitClicked = false;
  private errorMessage = "";
  private formErrorMessage = {};
  private complete = false;
  private formSubmissionCode: any;
  private saveMessage = "";
  profile$: Observable<any>;
  currentUser: any;
  private requiredFieldStatement =
    "Required fields are marked by an asterisk (*)";
  private SUBMISSION_ERROR_MESSAGE =
    "* An error has occurred. Please try again.";
  private XSS_INJECTION_ERROR = "Kindly provide valid data.";
  private VALIDATION_ERROR_MESSAGE =
    "* Missing/invalid answers. Please check your answers.";
  private SAVE_MESSAGE = "Your form has been successfully saved.";
  private EMPTY_SAVE_MESSAGE = "Sorry , empty form can not be saved.";

  constructor(
    private _formLoaderService: FormLoaderService,
    private _formvalidationService: FormValidationService,
    private store: Store<any>,
  ) {}

  ngOnInit() {
    this.statusChange.emit(this.formStatusChange(FORM_STATUS.LOADING, "", ""));
    if (this.mode === MODE.EDIT || this.mode === MODE.READONLY) {
      this.formSubmissionCode = this.formSubCode;
    }

    this.profile$ = this.store.select("PERSON_REDUCER");

    this.profile$.subscribe((s) => {
      console.log("Current User Profile: ", s.user);
      this.currentUser = s.user;
      console.log(JSON.stringify(this.currentUser, null, 2));
      this.campusCode = s.user.campusCode;
    });

    this._formLoaderService
      .getForm(
        this.formCode,
        this.formVerCode,
        this.formSubCode,
        this.campusCode,
      )
      .then((data) => {
        this.survey = data;

        let isCompleted = this.survey.complete;
        let isErrorScenario = false;

        if (
          this.formSubmissionCode &&
          isCompleted === true &&
          this.mode === MODE.EDIT
        ) {
          this.statusChange.emit(
            this.formStatusChange(FORM_STATUS.ERROR, "", ""),
          );
          isErrorScenario = true;
        }

        if (
          this.formSubmissionCode &&
          isCompleted === false &&
          this.mode === MODE.AMEND
        ) {
          this.statusChange.emit(
            this.formStatusChange(FORM_STATUS.ERROR, "", ""),
          );
          isErrorScenario = true;
        }

        if (
          !this.formSubmissionCode &&
          isCompleted === false &&
          this.mode === MODE.READONLY
        ) {
          this.statusChange.emit(
            this.formStatusChange(FORM_STATUS.ERROR, "", ""),
          );
          isErrorScenario = true;
        }

        if (
          !this.formSubmissionCode &&
          isCompleted === false &&
          this.mode === MODE.AMEND
        ) {
          this.statusChange.emit(
            this.formStatusChange(FORM_STATUS.ERROR, "", ""),
          );
          isErrorScenario = true;
        }

        if (!isErrorScenario) {
          this.form = this._formLoaderService.buildForm(data);
          this.form.valueChanges.subscribe(() => {
            if (this.form.valid) {
              this.errorMessage = "";
            }
          });
          if (this.survey.campusCode) {
            this.campusCode = this.survey.campusCode;
          }
          /*if (!isCompleted && this.mode !=== MODE.READONLY) {
                this.form.valueChanges.debounceTime(60000).subscribe(data => this.save(this.form));
            }*/
          this.statusChange.emit(
            this.formStatusChange(FORM_STATUS.LOADED, "", ""),
          );
        }
      })
      .catch((error) => {
        this.formErrorMessage = <any>error.url;
        this.statusChange.emit(
          this.formStatusChange(FORM_STATUS.ERROR, "", error),
        );
      });
  }

  ngOnChanges(changes: any) {
    if (changes.enableSave) {
      this.enableSave = changes.enableSave.currentValue;
    }

    if (this.mode === MODE.AMEND) {
      this.formSubmissionCode = "";
    }
  }

  submit(form) {
    let submissionCode;
    this.isSubmitClicked = true;
    if (this.form.valid) {
      this.disableButton = true;
      this.isFormDisabled = true;
      if (!this.formSubmissionCode) {
        form.value.complete = true;
        console.log("going to submit form");
        this._formLoaderService
          .postForm(form.value, this.currentUser.userId, this.campusCode)
          .then((data) => {
            submissionCode = data["submissionCode"];
            this.disableButton = false;
            this.isFormDisabled = false;
            if (submissionCode) {
              this.statusChange.emit(
                this.formStatusChange(
                  FORM_STATUS.SUBMITTED,
                  submissionCode,
                  "",
                ),
              );
            }
          })
          .catch((err) => {
            this.handleError(err.status);
          });
      } else {
        form.value.complete = true;
        this._formLoaderService
          .putForm(
            form.value,
            this.env,
            this.formSubmissionCode,
            this.currentUser.userId,
          )
          .then((data) => {
            submissionCode = data;
            this.disableButton = false;
            this.isFormDisabled = false;
            if (submissionCode) {
              this.statusChange.emit(
                this.formStatusChange(
                  FORM_STATUS.SUBMITTED,
                  this.formSubmissionCode,
                  "",
                ),
              );
            }
          })
          .catch((err) => {
            this.handleError(err.status);
          });
      }
    } else {
      this.errorMessage = this.VALIDATION_ERROR_MESSAGE;
      this.saveMessage = "";
    }
  }

  handleError(status) {
    this.disableButton = false;
    this.isFormDisabled = false;
    status === 400
      ? (this.errorMessage = this.XSS_INJECTION_ERROR)
      : (this.errorMessage = this.SUBMISSION_ERROR_MESSAGE);
    this.saveMessage = "";
    this.statusChange.emit(
      this.formStatusChange(FORM_STATUS.ERROR, "", this.errorMessage),
    );
  }

  save(form) {
    let submissionCode;
    if (this.emptyResponseSave(form.value)) {
      if (!this.formSubmissionCode) {
        form.value.complete = false;
        this._formLoaderService
          .postForm(form.value, this.currentUser.userId, this.campusCode)
          .then((data) => {
            submissionCode = data["submissionCode"];
            this.formSubmissionCode = submissionCode;
            if (this.formSubmissionCode) {
              this.statusChange.emit(
                this.formStatusChange(
                  FORM_STATUS.SAVED,
                  this.formSubmissionCode,
                  "",
                ),
              );
            } else {
              this.errorMessage = this.SUBMISSION_ERROR_MESSAGE;
              this.saveMessage = "";
              this.statusChange.emit(
                this.formStatusChange(FORM_STATUS.ERROR, "", this.errorMessage),
              );
            }
          });
      } else {
        form.value.complete = false;
        this._formLoaderService
          .putForm(
            form.value,
            this.env,
            this.formSubmissionCode,
            this.currentUser.userId,
          )
          .then((data) => {
            submissionCode = this.formSubmissionCode;
            if (submissionCode) {
              this.statusChange.emit(
                this.formStatusChange(FORM_STATUS.SAVED, submissionCode, ""),
              );
            } else {
              this.errorMessage = this.SUBMISSION_ERROR_MESSAGE;
              this.saveMessage = "";
              this.statusChange.emit(
                this.formStatusChange(FORM_STATUS.ERROR, "", this.errorMessage),
              );
            }
          });
      }
      this.saveMessage = this.SAVE_MESSAGE;
    } else {
      this.saveMessage = this.EMPTY_SAVE_MESSAGE;
    }
    this.form.valueChanges.subscribe((data) => {
      if (this.SAVE_MESSAGE) {
        this.saveMessage = "";
      }
    });
    this.errorMessage = "";
  }

  cancel() {
    this.statusChange.emit(this.formCode);
  }

  formStatusChange(status: string, submissionCode: string, errorMessage: any) {
    return {
      status: status,
      submissionCode: submissionCode ? submissionCode : "",
      timestamp:
        status === FORM_STATUS.SAVED || status === FORM_STATUS.SUBMITTED
          ? new Date().toISOString()
          : "",
      errorMessage: errorMessage ? errorMessage : "",
    };
  }

  emptyResponseSave(data: any) {
    let isEmptyResponse = false;
    if (data.formSections instanceof Array) {
      for (let i = 0; i < data.formSections.length; i++) {
        data.formSections[i].responses = data.formSections[i].responses.filter(
          (question) => {
            let control = this._formvalidationService.getQuestionControl(
              question.questionSequenceCode,
            );
            if (control !== undefined) {
              if (control.value !== "" && control.value !== null) {
                isEmptyResponse = true;
              }
            }
            return true;
          },
        );
      }
    }
    return isEmptyResponse;
  }
}



// WEBPACK FOOTER //
// /home/runner/work/slipresistant/slipresistant/client/src/app/form/form.component.ts